import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";

const HERO_IMAGE_URL =
  "https://customer-assets.emergentagent.com/job_d582ae50-a247-44fb-9b58-4427c8780cce/artifacts/5t73tlky_F3B68005-0404-413B-BD07-5A707781D3FD.png";

export default function Hero() {
  const navigate = useNavigate();
  const goBooking = () => navigate("/schedule");
  const goSchedule = () => navigate("/schedule");

  return (
    <section
      data-testid="hero-section"
      className="relative w-full min-h-screen overflow-hidden pt-20 md:pt-24"
    >
      {/* Full-bleed image (below navbar) */}
      <div
        className="absolute left-0 right-0 bottom-0 top-20 md:top-24 bg-contain md:bg-cover bg-no-repeat bg-center md:bg-top"
        style={{ backgroundImage: `url('${HERO_IMAGE_URL}')`, backgroundColor: "#0A0B10" }}
        role="img"
        aria-label="Ibiza Poolside Villa Resort — Private Luxury Villa"
        data-testid="hero-image"
      />

      {/* Subtle bottom gradient so CTAs read clearly */}
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0A0B10] via-[#0A0B10]/40 to-transparent pointer-events-none" />

      {/* Floating CTAs */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.4 }}
        className="absolute inset-x-0 bottom-6 sm:bottom-10 md:bottom-14 z-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-6"
      >
        <Button
          onClick={goBooking}
          className="gold-btn rounded-full px-6 sm:px-8 py-5 sm:py-6 text-sm tracking-wide shadow-2xl w-full sm:w-auto"
          data-testid="hero-book-now"
        >
          Reserve Your Date
        </Button>
        <Button
          onClick={goSchedule}
          variant="outline"
          className="outline-gold-btn rounded-full px-6 sm:px-8 py-5 sm:py-6 text-sm tracking-wide bg-black/40 backdrop-blur-sm w-full sm:w-auto"
          data-testid="hero-explore"
        >
          View Availability
        </Button>
      </motion.div>
    </section>
  );
}
